import { apiRequest } from "./client";

export type FieldObservationStatus = "scheduled" | "completed" | "cancelled";

export interface FieldObservationOut {
  id: number;
  trainee_user_id: number;
  mentor_user_id: number | null;
  course_id: number | null;
  title: string;
  scheduled_at: string | null;
  completed_at: string | null;
  status: FieldObservationStatus;
  mentor_comment: string | null;
  created_at: string;
}

export interface CreateObservationPayload {
  trainee_user_id: number;
  mentor_user_id?: number | null;
  course_id?: number | null;
  title: string;
  scheduled_at?: string | null;
}

export function listMyObservations(): Promise<FieldObservationOut[]> {
  return apiRequest<FieldObservationOut[]>("/field-practice/me");
}

export function listAsMentor(): Promise<FieldObservationOut[]> {
  return apiRequest<FieldObservationOut[]>("/field-practice/mentor");
}

export function listForUser(userId: number): Promise<FieldObservationOut[]> {
  return apiRequest<FieldObservationOut[]>(`/field-practice/users/${userId}`);
}

export function createObservation(
  payload: CreateObservationPayload,
): Promise<FieldObservationOut> {
  return apiRequest<FieldObservationOut>("/field-practice", {
    method: "POST",
    body: payload,
  });
}

export function completeObservation(
  id: number,
  comment?: string,
): Promise<FieldObservationOut> {
  return apiRequest<FieldObservationOut>(`/field-practice/${id}/complete`, {
    method: "POST",
    body: { comment },
  });
}

export function cancelObservation(id: number): Promise<FieldObservationOut> {
  return apiRequest<FieldObservationOut>(`/field-practice/${id}/cancel`, {
    method: "POST",
  });
}
